export default class ClientBillingInfo {
    clientNumber: number;
    dayRate: number;
    mileageRate: number;
    billBy: string;
    mealReceipt: boolean;
    chargeBackup: boolean;
    chargeOp: boolean;
    flatRate: boolean;
    superFee: number;
    officeBreakdown: boolean;
    invoiceFormat: string;
    invoiceFactor: number;
    invoicePeriod: string;
    preparedDate: boolean;
    emailInvoice: boolean;
    backupRate: number;
    dunsNumber: string;
    remitDept: string;
    contactName: string;
    contactPhone: string;
    contactEmail: string;
    apWebsite: string;
    chargeBpAtCost: boolean;
    chargeBpPercentage: number;
    billOtherProspect: boolean;
    enterClProspectNo: boolean;
    enterClProspectName: boolean;
    enterClAfeNo: boolean;
    enterClAccountNo: boolean;
    groupInvoices: boolean;
    requireMileageDest: boolean;
    subCodeRequired: boolean;
    isTurnkeyBilling: boolean;
    roundDays: boolean;
    nameOnInvoice: boolean;
    adjustInvoicePercentage: boolean;
    id: number;
    mode: number;
    printFinalOnInvoice: boolean;
    omitSubTimesheet: boolean;
    totalAfeInvoiceCheck: boolean;
    afeWarningPercentage: number;
    invoiceFrequency: string;
    printAfeStatus: boolean;
    invoiceDueDays: number;
    currentInstructions: string;
}



// WEBPACK FOOTER //
// ./src/models/ClientBillingInfo.ts